import isString from 'lodash/fp/isString';
import { useCallback, FC, ReactChild } from 'react';

import { Info, PlanFeatureWithTooltip, PricingTooltip } from './Wrapper';

export type PlanFeatureInfoProps = {
  tooltipContent?: ReactChild;
};

const PlanFeatureInfo: FC<PlanFeatureInfoProps> = ({ tooltipContent }) => {
  const renderTooltip = useCallback(
    () =>
      isString(tooltipContent) ? (
        <span
          dangerouslySetInnerHTML={{
            __html: tooltipContent
          }}
        ></span>
      ) : (
        <span>{tooltipContent}</span>
      ),
    []
  );
  return (
    <PlanFeatureWithTooltip>
      <PricingTooltip withArrow variant="black" direction="above" delayHide={100} renderContent={renderTooltip}>
        <Info />
      </PricingTooltip>
    </PlanFeatureWithTooltip>
  );
};

export default PlanFeatureInfo;
